import { Heading } from "src/components/ui/heading"
import { css } from "styled-system/css"

export default function () {
  return (
    <article class={css({
      display: 'grid',
      gap: 3
    })}>

      <p>These guidelines apply to our chatrooms, live webinars and all other means of communication with our trade leaders.</p>

      <Heading textStyle='2xl' my={6}>Key-rule:</Heading>

      <p>We are not a trade signal service – We teach you a method and provide the tools to do so. How you employ the method is YOUR business and is in your hands.</p>

      <Heading textStyle='2xl' my={6}>We are glad to help you with:</Heading>

      <p>Questions about HVF theory.</p>

      <p>Questions about Trading HVFs.</p>

      <p>Questions about Francis’s shares.</p>

      <p>Questions about HVF setups.</p>

      <p>Questions about navigating the Sniper Circle and the community.</p>

      <p>Emotional support in regards to trading if necessary</p>

      <Heading textStyle='2xl' my={6}>We cannot help you with:</Heading>

      <p>Technical Questions – Broker, internet, VPN, and computer issues. Please lookout for external resources that fit your issue.</p>

      <p>Financial Structures – Tax, legal, accounting</p>

      <p>Questions regarding your Investment positions and decisions</p>

      <p>Questions regarding non HVF trades.</p>

      <p>Questions regarding your deviation from the HVF method.</p>

      <p>Please be aware that “Trade Leaders” are volunteering their time and are not employees of the community.</p>

      <p>For all other inquiries please contact us at support@themarketsniper.com</p>

    </article>
  )
}

